<template>

    <div v-if="!editing" class="w-full relative">
        <p v-if="modelValue !== null && modelValue.length > 0" class="text-base" :class="{'text-5xl font-bold': size ==='xl', 'text-2xl': size ==='l'}">
            {{ modelValue }}
        </p>
        <p v-else class="text-base text-gray-600" :class="{'text-5xl font-bold': size ==='xl', 'text-2xl': size ==='l'}">
            <i>Edit to add</i>
        </p>
        <svg class="w-6 h-6 absolute -right-9 top-0 cursor-pointer" @click="edit" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" d="M16.862 4.487l1.687-1.688a1.875 1.875 0 112.652 2.652L6.832 19.82a4.5 4.5 0 01-1.897 1.13l-2.685.8.8-2.685a4.5 4.5 0 011.13-1.897L16.863 4.487zm0 0L19.5 7.125" />
        </svg>
    </div>
    <div v-else class="relative flex flex-col -my-1.5 -mx-0.5">
        <ul class="absolute -top-7 -right-1.5 flex align-center space-x-1 mb-1.5">
            <li @click="cancel" class="rounded-t bg-gray-100 text-gray-700 px-2 cursor-pointer">Cancel</li>
            <li @click="save" class="rounded-t bg-indigo-600 text-gray-100 px-2 cursor-pointer">Save</li>
        </ul>
        <input
            v-model="newValue"
            type="text"
            class="w-auto inline-block p-1 -m-1 text-base"
            :class="{'text-5xl p-1.5 -m-1.5 font-bold': size ==='xl', 'text-2xl': size ==='l', 'bg-gray-600 m-5 bg-opacity-25': transparent}"
        >
    </div>
</template>

<script setup>
import {ref} from "vue";

const editing = ref(false)

const props = defineProps({
    'modelValue': String,
    size: {
        type: String,
        required: false,
        default: 'base'
    },
    transparent: {
        type: Boolean,
        required: false,
        default: false
    }
})
const emit = defineEmits(['update:modelValue', 'saved'])

const newValue = ref('')

function edit() {
    newValue.value = props.modelValue;
    editing.value = true;
}

function cancel() {
    editing.value = false;
}

function save() {
    emit('update:modelValue', newValue.value)
    emit('saved', newValue.value)
    editing.value = false;
}
</script>
